"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight, Scale } from "lucide-react";
import Link from "next/link";
import { useMemo } from "react";
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";
import { I18nText } from "@/components/I18nText";
import { getLocalizedComparison } from "@/lib/comparisons";
import { useI18n } from "@llmgateway/i18n/react";
import type { ComparisonSummary, LocalizedComparisonGroup } from "@/lib/comparisons";
interface CompareIndexClientProps {
  comparisons: LocalizedComparisonGroup<ComparisonSummary>[];
}
export function CompareIndexClient(t0) {
  const $ = _c(19);
  const {
    comparisons
  } = t0;
  const {
    locale
  } = useI18n();
  let t1;
  if ($[0] !== comparisons || $[1] !== locale) {
    let t2;
    if ($[3] !== locale) {
      t2 = group => getLocalizedComparison(group, locale);
      $[3] = locale;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== locale) {
      t3 = (a, b) => a.competitor.localeCompare(b.competitor, locale);
      $[5] = locale;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t1 = comparisons.map(t2).toSorted(t3);
    $[0] = comparisons;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const entries = t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Header />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-muted/60 via-transparent to-transparent" />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-border/60 bg-muted/50 px-4 py-1.5 text-sm text-muted-foreground"><Scale className="h-3.5 w-3.5" /><I18nText translationKey="compare.eyebrow" /></div>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h1 className="text-4xl font-bold tracking-tight sm:text-5xl"><I18nText translationKey="compare.indexTitle" /></h1>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="relative overflow-hidden border-b">{t3}<div className="container relative mx-auto max-w-4xl px-4 pt-20 pb-12 sm:pt-24 text-center">{t4}{t5}<p className="mx-auto mt-5 max-w-xl text-lg leading-relaxed text-muted-foreground"><I18nText translationKey="compare.indexDescription" /></p></div></section>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== entries) {
    t7 = entries.map(_temp);
    $[12] = entries;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <main>{t6}<section className="px-4 py-12"><div className="container mx-auto max-w-4xl"><div className="grid gap-5 sm:grid-cols-2">{t7}</div></div></section></main>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Footer />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8) {
    t10 = <div className="min-h-screen bg-background">{t2}{t8}{t9}</div>;
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}
function _temp(entry) {
  return <Link key={entry.id} href={`/compare/${entry.slug}`} className="group flex flex-col rounded-2xl border bg-card p-6 shadow-sm transition-colors hover:border-foreground/30"><div className="mb-3 flex items-center gap-2 text-sm font-medium text-muted-foreground"><span className="text-foreground">DevPass</span><span className="text-muted-foreground/50"><I18nText translationKey="compare.vs" /></span><span>{entry.competitor}</span></div><p className="flex-1 text-sm leading-6 text-muted-foreground">{entry.verdict}</p><div className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-foreground"><I18nText translationKey="compare.readComparison" /><ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></div></Link>;
}